import React from 'react'
import { Drawer, Button, Input, Icon } from 'antd'
import CommentInput from '../../CommentInput'
import EntitySelectorList from '../../EntitySelectorList'

const SettingsDrawer = ({
  visible,
  selectedSettings,
  formData,
  setFormData,
  onClose,
  updateSettings,
  saveSettings
}) => {
  return (
    <Drawer
      title="Shot Editor"
      placement="right"
      closable={true}
      onClose={onClose}
      visible={visible}
      width={400}
    >
      {selectedSettings && (
        <div className="settings-drawer-content">
          <CommentInput
            text={selectedSettings.initial_image_prompt}
            placeholder="Write your image prompt..."
            characterList={formData.characterList}
            locationReference={formData.locationReference}
            selectedCharacter={formData.selectedCharacter}
            locationMap={formData.locationMap}
            outfitMap={formData.outfitMap}
            outfitsReference={formData.outfits_reference}
            outfits={formData.outfits}
            propMap={formData.propMap}
            propsReference={formData.props_reference || formData.propReference}
            onChange={value => updateSettings('initial_image_prompt', value)}
          />

          <EntitySelectorList
            activePrompt={
              selectedSettings.initial_image_prompt &&
              selectedSettings.initial_image_prompt.length < 1000
                ? selectedSettings.initial_image_prompt
                : ''
            }
            onUpdatePrompt={newText =>
              updateSettings('initial_image_prompt', newText)
            }
            formData={{ ...formData, setFormData }}
            disabled={false}
          />
          <div className="setting-group">
            <CommentInput
              label="Voiceover Text"
              text={selectedSettings.voiceover_text}
              onChange={value => updateSettings('voiceover_text', value)}
              placeholder="Write your voiceover text..."
              characterList={formData.characterList}
              locationReference={formData.locationReference}
              selectedCharacter={formData.selectedCharacter}
              locationMap={formData.locationMap}
              outfitMap={formData.outfitMap}
              outfitsReference={formData.outfits_reference}
              outfits={formData.outfits}
              propMap={formData.propMap}
              propsReference={
                formData.props_reference || formData.propReference
              }
            />
          </div>
          <div className="setting-group">
            <CommentInput
              label="Lighting"
              text={selectedSettings.lighting}
              onChange={value => updateSettings('lighting', value)}
              placeholder="Write your lighting text..."
              characterList={formData.characterList}
              locationReference={formData.locationReference}
              selectedCharacter={formData.selectedCharacter}
              locationMap={formData.locationMap}
              outfitMap={formData.outfitMap}
              outfitsReference={formData.outfits_reference}
              outfits={formData.outfits}
              propMap={formData.propMap}
              propsReference={
                formData.props_reference || formData.propReference
              }
            />
          </div>
          <div className="setting-group">
            <CommentInput
              label="Scenery"
              text={selectedSettings.scenery}
              onChange={value => updateSettings('scenery', value)}
              placeholder="Write your scenery text..."
              characterList={formData.characterList}
              locationReference={formData.locationReference}
              selectedCharacter={formData.selectedCharacter}
              locationMap={formData.locationMap}
              outfitMap={formData.outfitMap}
              outfitsReference={formData.outfits_reference}
              outfits={formData.outfits}
              propMap={formData.propMap}
              propsReference={
                formData.props_reference || formData.propReference
              }
            />
          </div>

          <Button
            type="primary"
            onClick={saveSettings}
            style={{ marginTop: 16, width: '100%' }}
          >
            Apply Changes
          </Button>
        </div>
      )}
    </Drawer>
  )
}

export default SettingsDrawer
